export default "https://assets.pclncdn.com/web/next-landing/d6942e80/_next/static/images/Two-43f2bfbd4854c2d779530dca660b1708.svg";